'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import type React from 'react';
import styles from './styles.module.css';

const AdTypeTabs: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const decodedPath = decodeURIComponent(pathname || '');
  const segments = decodedPath.split('/').filter(Boolean);

  // Detect if maps-based routing; according to existing logic it's segments[0] === 'maps'
  const isMaps = segments[0] === 'maps';
  const cityIndex = isMaps ? 2 : 1;

  // Determine current ad type from path or query
  const adTypeFromPath = (() => {
    const adTypeIdx = isMaps ? cityIndex + 1 : cityIndex + 1;
    const seg = segments[adTypeIdx];
    return seg === 'rent' || seg === 'sale' ? seg : '';
  })();
  const adTypeFromQuery = (searchParams?.get('filters[ad_type]') ||
    searchParams?.get('filters%5Bad_type%5D') ||
    '') as string;
  const currentAdType = (adTypeFromPath || adTypeFromQuery || 'sale') as
    | 'sale'
    | 'rent';

  const onChangeAdType = (value: 'sale' | 'rent') => {
    // If ad type is defined in the path (/[type]/[city]/[adType]), replace that segment
    const adTypeIdx = isMaps ? cityIndex + 1 : cityIndex + 1;
    const inPath =
      segments[adTypeIdx] === 'sale' || segments[adTypeIdx] === 'rent';
    if (inPath) {
      const nextSegments = [...segments];
      nextSegments[adTypeIdx] = value;
      const params = new URLSearchParams(searchParams?.toString() || '');
      // ensure page reset
      params.set('page', '1');
      const newPath =
        '/' +
        nextSegments
          .filter(Boolean)
          .map((s) => encodeURIComponent(s))
          .join('/');
      const qs = params.toString();
      router.push(qs ? `${newPath}?${qs}` : newPath, { scroll: false });
      return;
    }
    // Otherwise, change only the query parameter filters[ad_type]
    const params = new URLSearchParams(searchParams?.toString() || '');
    params.set('filters[ad_type]', value);
    params.set('page', '1');
    const qs = params.toString();
    router.push(qs ? `${pathname}?${qs}` : pathname || '/', { scroll: false });
  };

  return (
    <div className={styles.mb16}>
      <div
        className={styles.adTypeTabs}
        role="tablist"
        aria-label="Тип объявления"
      >
        {[
          { title: 'Купить', value: 'sale' as const },
          { title: 'Снять', value: 'rent' as const },
        ].map((tab) => (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={currentAdType === tab.value}
            className={`${styles.adTypeTab} ${currentAdType === tab.value ? styles.adTypeTabActive : ''}`}
            onClick={() =>
              currentAdType === tab.value ? null : onChangeAdType(tab.value)
            }
          >
            {tab.title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdTypeTabs;
